import { assetCreateShowsRegionField } from './assetCreateFormDefaults';

/** Browse list region filter — United States only (hidden for Israel and “all countries”). */
export function assetBrowseShowsRegionFilter(countryFilterId: string | number | null | undefined): boolean {
  if (countryFilterId === '' || countryFilterId === null || countryFilterId === undefined) {
    return false;
  }
  return assetCreateShowsRegionField(countryFilterId);
}
